<template>
	  <vue-dropzone
	  		v-if="!disabled"
			id="upload"
	  		ref="myVueDropzone"
			v-on:vdropzone-max-files-exceeded="blockUpload"
			v-on:vdropzone-file-added="removeResources"
			v-on:vdropzone-canceled="showUpload"
			v-on:vdropzone-sending="appendInfo"
			v-on:vdropzone-error="error"
			v-on:vdropzone-success="success"
			:options="{...config, maxFileSize, acceptedFiles}"
			useCustomSlot
		>
		<v-flex text-xs-center indigo--text my-3>
			<v-card color="grey lighten-2">
				<v-card-text>
					Clique aqui para anexar
				</v-card-text>
			</v-card>
		</v-flex>
	</vue-dropzone>

	<v-flex v-else text-xs-center indigo--text my-3>
			<v-card color="grey lighten-2">
				<v-card-text>
					Clique aqui para anexar
				</v-card-text>
			</v-card>
		</v-flex>
  </template>

  <script>
  import { mapActions, mapGetters } from 'vuex';
  import vueDropzone from "vue2-dropzone";

  export default {
	props:{
		coObjeto: {
			type: Number,
			default: -1
		},
		tpArquivo: {
			type: String,
			default: ''
		},
		filePath: {
			type: String,
			default: ''
		},
		maxFileSize: {
			type: Number,
			default: 102400000,
		},
		acceptedFiles: {
			type: String,
			default: 'application/pdf, image/jpeg, application/zip, application/x-rar-compressed, application/vnd.rar'
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data: () => ({
	  config: {
		url: `${process.env.VUE_APP_API_HOST}/upload/file/single/`,
		maxFiles: 1,
		uploadMultiple: false,
		chunking: true,
		chunkSize: 2048000, // Bytes
		// addRemoveLinks: true,
	  },
	}),
	components: {
	  vueDropzone
	},
	methods: {
		...mapActions({
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',

    }),
		appendInfo (file, xhr, formData) {
			this.$emit('upload');
			formData.append('co_objeto', this.coObjeto);
			formData.append('tp_arquivo', this.tpArquivo);
			formData.append('file_path', this.filePath);
		},
		blockUpload(file, error, xhr){
			this.definirMensagemErro('Já existe um arquivo anexado.');
			this.$refs.myVueDropzone.removeFile(file);
		},
		// deleteFile(file, error, xhr){
		// 	this.$emit('removerArquivo', JSON.stringify(file.xhr.response).co_arquivo);
		// 	this.$refs.myVueDropzone.dropzone.clickableElements[0].firstElementChild.style = 'display: block'
		// },
		removeResources(file, message, xhr){
			file.previewElement.querySelectorAll('.dz-success-mark')[0].style = 'display: none';
			file.previewElement.querySelectorAll('.dz-error-mark')[0].style = 'display: none';
			this.$refs.myVueDropzone.dropzone.clickableElements[0].firstElementChild.style = 'display: none'
		},
		error(file, message, xhr){
			this.definirMensagemErro('Arquivo não permitido!');
			this.$refs.myVueDropzone.removeFile(file)
			this.$refs.myVueDropzone.dropzone.clickableElements[0].firstElementChild.style = 'display: block'
		},
		success(file, response){
			this.$emit('sucesso');
		},
		showUpload(file, message, xhr){
			this.definirMensagemSucesso('Upload Cancelado');
			this.$refs.myVueDropzone.removeFile(file)
			this.$refs.myVueDropzone.dropzone.clickableElements[0].firstElementChild.style = 'display: block'
		}
	}
  };
  </script>
